// Lightweight theme toggle — flips a `theme-light` class on <body>, persisted in localStorage.
import { createContext, useContext, useEffect, useState } from "react";

const ThemeCtx = createContext({ theme: "dark", toggle: () => {} });

export const ThemeProvider = ({ children }) => {
    const [theme, setTheme] = useState(() => localStorage.getItem("vv_theme") || "dark");
    useEffect(() => {
        const root = document.body;
        if (theme === "light") root.classList.add("theme-light");
        else root.classList.remove("theme-light");
        localStorage.setItem("vv_theme", theme);
    }, [theme]);
    const toggle = () => setTheme((t) => (t === "light" ? "dark" : "light"));
    return <ThemeCtx.Provider value={{ theme, toggle }}>{children}</ThemeCtx.Provider>;
};

export const useTheme = () => useContext(ThemeCtx);
